<template>
  <div>
    <div class="row">
      <div class="col-12 mb-2">
        <div class="row align-items-center text-center">
          <div class="col-12 text-center">
            <button class="btn iconed btn-secondary" v-b-modal.problem-type><i
              class="icon-bd-plus"></i><span>جدید</span></button>
          </div>
        </div>
      </div>
      <div v-if="isLoading"  class="col-lg-12 p-0">
        <Preloader/>
      </div>
      <div class="col-lg-12 p-0" v-else>
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col" class="text-center">عملیات</th>
            <th scope="col" class="text-center">ردیف</th>
            <th scope="col" class="text-center">نوع مشکل</th>
            <th scope="col" class="text-center">مشکلات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) of problems">
            <td class="text-center">
              <button :id="'btn-problem-' + item.id" class="btn btn-secondary ml-2"
                      @click="editProblemType(item, index)"
                      data-toggle="tooltip"><i class="icon-bd-pencil"></i>
              </button>
              <button :id="'btn-delete-' + item.id" class="btn btn-secondary"
                      @click="onDeleteClicked(item, index)"><i class="icon-bd-delete"></i></button>
            </td>
            <th scope="row" class="text-center">{{index + 1}}</th>
            <td class="text-center">{{item.name}}</td>
            <td class="text-center">
              <button :id="'btn-problemItems-' + item.id" class="btn btn-secondary"
                      @click="onShowProblemItems(item, index)"><i
                class="icon-eye-outline"></i></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-modal
      id="problem-type"
      ref="problemTypeModal"
      title="تعریف نوع مشکل"
      ok-title="ذخیره"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="نوع مشکل"
          label-for="name-input"
          invalid-feedback="نوع مشکل الزامیست"
        >
          <b-form-input
            id="name-input"
            v-model="name"
            :state="nameState"
            required
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>


    <b-modal
      id="problemTypeDetails"
      ref="problemTypeDetail"
      title="جزئیات مشکل"
      size="lg"
      ok-title="ذخیره"
      cancel-title="بستن"
      @ok="handleOk"
      ok-only
    >
      <problem-details v-bind:problem-type="problemType"></problem-details>
    </b-modal>

  </div>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import ShowProblemsModal from "../../components/ShowProblemsModal";
  import BaseService from "../../_framework/api/BaseService.js";
  import {mapState} from "vuex";
  import ProblemDetails from "../../components/ProblemDetails.vue"

  export default {
    name: "work-problems",
    components: {
      VsTable,
      ShowProblemsModal,
      ProblemDetails
    },
    data() {
      return {
        access: {},
        problems: [],
        deleteButtonState: 'primary',
        data: '',
        submittedNames: [],
        nameState: null,
        name: '',
        editProblemTypeFlag: false,
        problemType: {},
        isLoading: false,
      }
        ;
    },
    mounted() {
      this.getProblems();
    },
    methods: {

      getProblems() {
        this.isLoading = true;
        new BaseService('WorkProblems', '/GetProblemTypes').getList().then((response) => {
          // console.log(response.data);
          this.problems = response.data;
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          console.log(error)
        })
      },
      onDeleteClicked(item) {
        const $btnDel = $(`#btn-delete-${item.id}`);
        if (!$btnDel.hasClass("btn-danger")) {
          $btnDel.addClass("btn-danger");
          setTimeout(() => {
            $btnDel.removeClass("btn-danger");
          }, 2000);
        } else {
          new BaseService('WorkProblems', `/DeleteProblemType/${item.id}`).delete().then((response) => {
            this.$noty.success("حذف با موفقیت انجام شد");
            this.getProblems();
          }).catch((error) => {
            console.log(error)
          });
        }
      },
      createProblemType(name) {
        let createProblemType = {
          name: name
        };
        new BaseService('WorkProblems', '/CreateProblemType').create(createProblemType).then((response) => {
          this.$noty.success("ثبت با موفقیت انجام شد");
          this.getProblems();
        }).catch((error) => {
          console.log(error)
        });
      },
      updateProblemType(obj) {
        let updateProblemType = {
          id: obj.id,
          name: this.name,
        };

        new BaseService('WorkProblems', '/UpdateProblemType').update(updateProblemType).then((response) => {
          this.$noty.success("تغییرات با موفقیت صورت گرفت");
          this.getProblems();
          this.editProblemTypeFlag = false;
        }).catch((error) => {
          console.log(error)
        });
      },
      onShowProblemItems(item) {
        this.$refs['problemTypeDetail'].show();
        this.problemType = item;
      },
      editProblemType(item, index) {
        this.editProblemTypeFlag = true;
        this.$refs['problemTypeModal'].show();
        this.name = item.name;
        this.problemType = item

      },
      onCancelClicked() {

      },
      checkFormValidity() {
        const valid = this.$refs.form.checkValidity();
        this.nameState = valid ? 'valid' : 'invalid';
        return valid
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        }
        // Push the name to submitted names
        this.submittedNames.push(this.name);
        // Hide the modal manually
        this.$nextTick(() => {
          this.$refs.problemTypeModal.hide()
          this.editProblemTypeFlag = false
        })
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault();
        // Trigger submit handler
        this.handleSubmit();
        if (this.editProblemTypeFlag === false) {
          this.createProblemType(this.name)
        } else {
          this.updateProblemType(this.problemType);
          this.editProblemTypeFlag = false;
        }
      },
      resetModal() {
        this.name = '';
        this.nameState = null;
      },


    },
    created: () => {
    },
    /*beforeMount() {
        this.options.access = checkAccess(this.$route.path);
        //console.log(this.options.access);
        this.show = !!this.options.access;
    },*/
    computed: {
      ...mapState(["selectedRows", "currentService", "vsTableFeed"]),

    }
  };
</script>



